export default function useQuery(search) {
  return new URLSearchParams(search);
}